var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCommonArrowBackExtended(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15 15",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.85 6.64a.836.836 0 00-.471.14.922.922 0 00.005 1.43l5.564 4.487 1.062-1.328-5.63-4.54-.53 1.515h13.302A.85.85 0 0015 7.492a.85.85 0 00-.848-.851H3.259L7.01 3.615a.854.854 0 00.13-1.197.846.846 0 00-1.192-.13L.384 6.775c-.446.3-.548.992-.065 1.381l5.63 4.54c.88.712 1.943-.616 1.061-1.327L1.447 6.882c.064.055.064.055.12.12.27.337.216.83-.12 1.1l1.812-1.461H.85z",
    fill: "currentColor"
  })));
}

export default SvgCommonArrowBackExtended;